<template>
  <div>
    <h1 class="text-center py-4">Información general</h1>
    <div class="container">
      <article>
        <section
          class="alert alert-danger form-inline"
          v-show="counts.alerts.claimBuys"
        >
          <i class="material-icons text-white">comments</i
          ><span>Hay {{ counts.alerts.claimBuys }} reclamos pendientes</span>
        </section>
        <section
          class="alert alert-warning form-inline"
          v-show="counts.alerts.transacctions"
        >
          <i class="material-icons text-white">attach_money</i
          ><span
            >Hay {{ counts.alerts.transacctions }} transacciones
            pendientes</span
          >
        </section>
        <section class="alert alert-primary form-inline" v-show="1">
          <i class="material-icons text-white">attach_money</i
          ><span class="pr-2">Hay {{ 2 }} compras con envíos pendientes.</span>
          <router-link
            style="font-weight: bold"
            :to="{ name: 'PurchasesNotification' }"
            >Enviar recordatorio al vendedor</router-link
          >
        </section>
      </article>
      <article class="row">
        <section class="col-lg-4 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-success card-header-icon p-3">
              <div class="card-icon">
                <i class="material-icons">store</i>
              </div>
              <h2 class="text-dark">Activos</h2>
              <h3 class="card-title">
                {{ counts.publications.active }}
                <small
                  >publicaci{{ counts.publications.active != 1 ? "o" : "ó" }}n{{
                    counts.publications.active != 1 ? "es" : ""
                  }}</small
                >
              </h3>
            </div>
          </div>
        </section>
        <section class="col-lg-4 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-warning card-header-icon p-3">
              <div class="card-icon">
                <i class="material-icons">update</i>
              </div>
              <h2 class="text-dark">En espera</h2>
              <h3 class="card-title">
                {{ counts.publications.onHold }}
                <small
                  >publicaci{{ counts.publications.onHold != 1 ? "o" : "ó" }}n{{
                    counts.publications.onHold != 1 ? "es" : ""
                  }}</small
                >
              </h3>
            </div>
          </div>
        </section>
        <section class="col-lg-4 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-danger card-header-icon p-3">
              <div class="card-icon">
                <i class="material-icons">hourglass_top</i>
              </div>
              <h2 class="text-dark">Inactivos</h2>
              <h3 class="card-title">
                {{ counts.publications.inactive }}
                <small
                  >publicaci{{
                    counts.publications.inactive != 1 ? "o" : "ó"
                  }}n{{ counts.publications.inactive != 1 ? "es" : "" }}</small
                >
              </h3>
            </div>
          </div>
        </section>
        <section class="col-lg-6 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-primary card-header-icon p-3">
              <div class="card-icon">
                <i class="material-icons">sentiment_satisfied_alt</i>
              </div>
              <h2 class="text-dark">Usuarios</h2>
              <h3 class="card-title">
                {{ counts.users.all }}
                <small>en total</small>
              </h3>
            </div>
          </div>
        </section>
        <section class="col-lg-6 col-md-6 col-sm-6">
          <div class="card card-stats">
            <div class="card-header card-header-info card-header-icon p-3">
              <div class="card-icon">
                <i class="material-icons">record_voice_over</i>
              </div>
              <h2 class="text-dark">Esta semana</h2>
              <h3 class="card-title">
                {{ counts.users.news }}
                <small
                  >usuario{{ counts.users.news != 1 ? "s" : "" }} nuevo{{
                    counts.users.news != 1 ? "s" : ""
                  }}!</small
                >
              </h3>
            </div>
          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
import Api from "../../tools/Api2";

export default {
  name: "DashboardComponent",
  data() {
    return {
      counts: {
        alerts: {
          claimBuys: 0,
        },
        publications: {
          active: 0,
          inactive: 0,
          onHold: 0,
        },
        users: {
          all: 0,
          news: 0,
        },
      },
    };
  },
  created: function() {
    Api("count")
      .get("dashboard")
      .then((res) => {
        this.counts = {
          alerts: {
            claimBuys: res.products.claimBuys,
            transacctions: res.buys.transacctions,
          },
          publications: {
            active: res.products.active + res.services.active,
            inactive: res.products.inactive + res.services.inactive,
            onHold: res.products.onHold + res.services.onHold,
          },
          users: {
            all: res.users.all,
            news: res.users.lastWeek,
          },
        };
      });
  },
};
</script>

<style scoped src="./../../assets/css/dashboard.css"></style>
